import * as React from "react";
import { IconProps } from "./IconProps";

export const IconLayoutList = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="Action / Select">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.33301 3.33329C1.33301 2.9651 1.63148 2.66663 1.99967 2.66663H13.9997C14.3679 2.66663 14.6663 2.9651 14.6663 3.33329V12.6666C14.6663 13.0348 14.3679 13.3333 13.9997 13.3333H1.99967C1.63148 13.3333 1.33301 13.0348 1.33301 12.6666V3.33329ZM2.66634 3.99996V12H6.66634V3.99996H2.66634ZM7.99967 3.99996V12H13.333V3.99996H7.99967Z"
            fill={color}
          />
          <g id="Icon">
            <path
              d="M4.66634 6.33329C4.48225 6.33329 4.33301 6.18405 4.33301 5.99996C4.33301 5.81586 4.48225 5.66663 4.66634 5.66663C4.85044 5.66663 4.99967 5.81586 4.99967 5.99996C4.99967 6.18405 4.85044 6.33329 4.66634 6.33329Z"
              fill={color}
            />
            <path
              d="M4.66634 8.33329C4.48225 8.33329 4.33301 8.18405 4.33301 7.99996C4.33301 7.81586 4.48225 7.66663 4.66634 7.66663C4.85044 7.66663 4.99967 7.81586 4.99967 7.99996C4.99967 8.18405 4.85044 8.33329 4.66634 8.33329Z"
              fill={color}
            />
            <path
              d="M4.66634 10.3333C4.48225 10.3333 4.33301 10.1841 4.33301 9.99996C4.33301 9.81586 4.48225 9.66663 4.66634 9.66663C4.85044 9.66663 4.99967 9.81586 4.99967 9.99996C4.99967 10.1841 4.85044 10.3333 4.66634 10.3333Z"
              fill={color}
            />
          </g>
          <path
            id="Icon (Stroke)_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.66667 6.66671C4.29848 6.66671 4 6.36823 4 6.00004C4 5.63185 4.29848 5.33337 4.66667 5.33337C5.03486 5.33337 5.33333 5.63185 5.33333 6.00004C5.33333 6.36823 5.03486 6.66671 4.66667 6.66671ZM4.66667 8.66671C4.29848 8.66671 4 8.36823 4 8.00004C4 7.63185 4.29848 7.33337 4.66667 7.33337C5.03486 7.33337 5.33333 7.63185 5.33333 8.00004C5.33333 8.36823 5.03486 8.66671 4.66667 8.66671ZM4.66667 10.6667C4.29848 10.6667 4 10.3682 4 10C4 9.63185 4.29848 9.33337 4.66667 9.33337C5.03486 9.33337 5.33333 9.63185 5.33333 10C5.33333 10.3682 5.03486 10.6667 4.66667 10.6667ZM4.66667 6.33337C4.48257 6.33337 4.33333 6.18414 4.33333 6.00004C4.33333 5.81595 4.48257 5.66671 4.66667 5.66671C4.85076 5.66671 5 5.81595 5 6.00004C5 6.18414 4.85076 6.33337 4.66667 6.33337ZM4.66667 8.33337C4.48257 8.33337 4.33333 8.18414 4.33333 8.00004C4.33333 7.81595 4.48257 7.66671 4.66667 7.66671C4.85076 7.66671 5 7.81595 5 8.00004C5 8.18414 4.85076 8.33337 4.66667 8.33337ZM4.33333 10C4.33333 10.1841 4.48257 10.3334 4.66667 10.3334C4.85076 10.3334 5 10.1841 5 10C5 9.81595 4.85076 9.66671 4.66667 9.66671C4.48257 9.66671 4.33333 9.81595 4.33333 10Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
